import { render } from "./Home.vue?vue&type=template&id=05f2f50f&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=05f2f50f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f2f50f"]])

export default __exports__